<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>记录类型：</label>
                <el-select v-model="search_Obj.f_type" clearable placeholder="请选择" @keyup.enter.native="doSearch" style="width: 200px">
                    <el-option v-for="item in enuObj('record_type')" :key="'record_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>内容：</label>
                <el-input v-model="search_Obj.f_title" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="type" label="记录类型" sortable="custom" width="200">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.type, "record_type") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="内容" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="记录时间" sortable="custom" width="200"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看记录"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'recordList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '记录',
            menu_id: 1990,
            list_url: "/api/admin/record/list",
            search_Obj: {
                f_type: '',
                f_title: '',
            },
            del_Obj:{
                url:'/api/admin/record/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['record_type'],
        };
    },
    methods: {}
};
</script>